import type { FieldWidget } from "../types/formBuilderTypes";

export const fieldWidgets: { widget: FieldWidget; label: string }[] = [
  { widget: "shortText", label: "Short text" },
  { widget: "longText", label: "Long text" },
  { widget: "number", label: "Number" },
  { widget: "email", label: "Email" },
  { widget: "phone", label: "Phone" },
  { widget: "date", label: "Date" },
  { widget: "radio", label: "Single choice" },
  { widget: "dropdown", label: "Dropdown" },
  { widget: "multipleChoice", label: "Multiple choice" },
  { widget: "yesNo", label: "Yes / No" },
  { widget: "signature", label: "Signature" },
];

export function widgetLabel(widget: FieldWidget) {
  return fieldWidgets.find(entry => entry.widget === widget)!.label;
}

export function isChoiceWidget(widget: FieldWidget) {
  return widget === "radio" || widget === "dropdown" || widget === "multipleChoice";
}
